export default __webpack_public_path__ + "static/media/new1.8acb402c.jpg";